import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    overlayTrustpilotWidget: {
        minWidth: '306px',
        minHeight: '60px',
        padding: '18px',
        display: 'none',
        [theme.breakpoints.up('md')]: {
            position: 'absolute',
            display: 'flex',
            top: spacing.medium,
            right: spacing.medium,
            zIndex: 11,
        },
        '& div': {
            '& iframe': {},
        },
    },
    outsideShowTrustpilotWidget: {
        minHeight: '60px',
        display: 'flex',
        marginTop: spacing.small,
        marginLeft: '20px',
        marginRight: '20px',
        padding: '18px',
        justifyContent: 'center',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
}));
export default useStyles;
